<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="form-container">
      <h1>{{ 'onboardingUserCreate.title' | translate }}</h1>

      <form [formGroup]="userForm" (ngSubmit)="save()">
        <div class="form-grid">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUserCreate.fields.name.label' | translate }}</mat-label>
            <input matInput formControlName="name_user" maxlength="120" required>
            @if (userForm.get('name_user')?.hasError('required')) {
              <mat-error>
                {{ 'onboardingUserCreate.fields.name.requiredError' | translate }}
              </mat-error>
            }
            @if (userForm.get('name_user')?.hasError('minlength')) {
              <mat-error>
                {{ 'onboardingUserCreate.fields.name.minLengthError' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUserCreate.fields.lastName.label' | translate }}</mat-label>
            <input matInput formControlName="lastName_user" maxlength="120" required>
            @if (userForm.get('lastName_user')?.hasError('required')) {
              <mat-error>
                {{ 'onboardingUserCreate.fields.lastName.requiredError' | translate }}
              </mat-error>
            }
            @if (userForm.get('lastName_user')?.hasError('minlength')) {
              <mat-error>
                {{ 'onboardingUserCreate.fields.lastName.minLengthError' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUserCreate.fields.email.label' | translate }}</mat-label>
            <input matInput type="email" formControlName="email_user" maxlength="120" required>
            @if (userForm.get('email_user')?.hasError('required')) {
              <mat-error>
                {{ 'onboardingUserCreate.fields.email.requiredError' | translate }}
              </mat-error>
            }
            @if (userForm.get('email_user')?.hasError('email')) {
              <mat-error>
                {{ 'onboardingUserCreate.fields.email.emailError' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUserCreate.fields.password.label' | translate }}</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" required>
            <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
              <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (userForm.get('password')?.hasError('required')) {
              <mat-error>
                {{ 'onboardingUserCreate.fields.password.requiredError' | translate }}
              </mat-error>
            }
            @if (userForm.get('password')?.hasError('passwordStrength')) {
              <mat-error>
                {{ 'onboardingUserCreate.fields.password.strengthError' | translate }}
              </mat-error>
            }
          </mat-form-field>

          @if (userForm.get('password')?.touched || userForm.get('password')?.value) {
            <div class="password-requirements">
              <p class="requirements-title">{{ 'onboardingUserCreate.passwordRequirements.title' | translate }}</p>
              <ul class="requirements-list">
                <li [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasMinLength"
                  [class.invalid]="getPasswordErrors()?.hasMinLength === false">
                  <mat-icon>{{ (getPasswordErrors() === null || getPasswordErrors()?.hasMinLength) ? 'check_circle' : 'cancel' }}</mat-icon>
                  {{ 'onboardingUserCreate.passwordRequirements.minLength' | translate }}
                </li>
                <li [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasUpperCase"
                  [class.invalid]="getPasswordErrors()?.hasUpperCase === false">
                  <mat-icon>{{ (getPasswordErrors() === null || getPasswordErrors()?.hasUpperCase) ? 'check_circle' : 'cancel' }}</mat-icon>
                  {{ 'onboardingUserCreate.passwordRequirements.upperCase' | translate }}
                </li>
                <li [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasLowerCase"
                  [class.invalid]="getPasswordErrors()?.hasLowerCase === false">
                  <mat-icon>{{ (getPasswordErrors() === null || getPasswordErrors()?.hasLowerCase) ? 'check_circle' : 'cancel' }}</mat-icon>
                  {{ 'onboardingUserCreate.passwordRequirements.lowerCase' | translate }}
                </li>
                <li [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasNumber"
                  [class.invalid]="getPasswordErrors()?.hasNumber === false">
                  <mat-icon>{{ (getPasswordErrors() === null || getPasswordErrors()?.hasNumber) ? 'check_circle' : 'cancel' }}</mat-icon>
                  {{ 'onboardingUserCreate.passwordRequirements.number' | translate }}
                </li>
                <li [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasSpecialChar"
                  [class.invalid]="getPasswordErrors()?.hasSpecialChar === false">
                  <mat-icon>{{ (getPasswordErrors() === null || getPasswordErrors()?.hasSpecialChar) ? 'check_circle' : 'cancel' }}</mat-icon>
                  {{ 'onboardingUserCreate.passwordRequirements.specialChar' | translate }}
                </li>
              </ul>
              <button type="button" mat-raised-button color="primary" (click)="generatePassword()" class="generate-password-btn">
                <mat-icon>vpn_key</mat-icon>
                {{ 'onboardingUserCreate.generatePasswordButton' | translate }}
              </button>
            </div>
          }

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="roleId" required>
              @for (role of roles; track role) {
                <mat-option [value]="role.id">
                  {{ role.name }}
                </mat-option>
              }
            </mat-select>
            @if (userForm.get('roleId')?.hasError('required')) {
              <mat-error>
                El rol es requerido.
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-actions">
          <button type="button" mat-raised-button (click)="goBack()" class="cancel-btn">
            {{ 'onboardingUserCreate.buttons.cancel' | translate }}
          </button>
          <button type="submit" mat-raised-button color="primary" [disabled]="userForm.invalid">
            {{ 'onboardingUserCreate.buttons.save' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</body>
